export const timerSpansQueryKey = ["timer_spans"] as const;
